const UI = `
    <div class="gna-buttons">
        <div class="gna-buttons-vertical">
            <button id="gna-home-button"><i class="fas fa-house"></i></button>
            <button id="gna-zoom-in-button"><i class="fa-solid fa-plus"></i></button>
            <button id="gna-zoom-out-button"><i class="fa-solid fa-minus"></i></button>
            <button id="gna-location-button"><i class="fa-solid fa-location-crosshairs"></i></button>
        </div>

        <button id="gna-toggle-map-button"><i class="fa-solid fa-layer-group"></i></button>
        <div class="gna-right-top-buttons">
            <button id="gna-open-sidebar-button"><i class="fa-solid fa-bars"></i></button>
        </div>
    </div>
    <div class="gna-sidebar" id="gna-sidebar">
        <div class="gna-sidebar-header">
            <button id="gna-close-sidebar-button"><i class="fa-solid fa-xmark" style="color: #ff0000; font-size: 25px;"></i></button>
        </div>
        <div class="gna-sidebar-content">
            <li class="gna-map-type" id="gna-dati-map-type">
                <label for="gna-dati-map-type-radio">
                    <input
                        type="radio"
                        class="gna-map-type-radio"
                        id="gna-dati-map-type-radio"
                        name="gna-map-type"
                        checked
                    />
                    <img
                        src="https://gna.cultura.gov.it/images/home1.jpg"
                        class="SBImg"
                        alt="Apri sezione nella mappa"
                        title="Apri sezione nella mappa"
                        class="image-thumb"
                        loading="lazy"
                    />
                    <h2>Dati GNA</h2>
                    <div class="gna-more-options-label">
                        <label class="gna-checkbox-layer-label" for="gna-dati-checkbox-punti">
                            <input
                                type="checkbox"
                                id="gna-dati-checkbox-punti"
                                checked
                            />Siti (punti): <span id="total-points">0</span></label
                        >
                        <label class="gna-checkbox-layer-label" for="gna-dati-checkbox-linee"
                            ><input
                                type="checkbox"
                                id="gna-dati-checkbox-linee"
                                checked
                            />Siti (linee): <span id="total-lines">0</span></label
                        >
                        <label class="gna-checkbox-layer-label" for="gna-dati-checkbox-poligoni"
                            ><input
                                type="checkbox"
                                id="gna-dati-checkbox-poligoni"
                                checked
                            />Siti (poligoni): <span id="total-polygons">0</span></label
                        >
                        <label class="gna-point-description">
                            <div class="gna-legend-point pointYellow"></div>
                            Elemento structturale
                        </label>
                        <label class="gna-point-description">
                            <div class="gna-legend-point pointPurple"></div>
                            Tracce di frequentazione 
                        </label>
                        <label class="gna-point-description">
                            <div class="gna-legend-point pointHollow"></div>
                            Indagine con esito negativo
                        </label>
                        <label class="gna-point-description">
                            <div class="gna-legend-point pointGreen"></div>
                            Elemento geo-paleontologico 
                        </label>
                        <label class="gna-checkbox-layer-label" for="gna-dati-checkbox-progetti"
                            ><input
                                type="checkbox"
                                id="gna-dati-checkbox-progetti"
                                checked
                            />Progetti</label
                        >
                        <label class="gna-point-description">
                            <div class="recGrey"></div>
                            Modulo di progetto
                        </label>
                        <label class="gna-checkbox-layer-label" for="gna-dati-checkbox-ricostruti-linee"
                            ><input
                                type="checkbox"
                                id="gna-dati-checkbox-ricostruti-linee"
                                checked
                            />Siti ricostruiti (linee)</label
                        >
                        <label class="gna-point-description">
                            <div class="lineGrey"></div>
                            Siti (Poligoni)
                        </label>
                        <label class="gna-checkbox-layer-label" for="gna-dati-checkbox-ricostruti-poligoni"
                            ><input
                                type="checkbox"
                                id="gna-dati-checkbox-ricostruti-poligoni"
                                checked
                            />Siti ricostruiti (poligoni)</label
                        >
                        <label class="gna-point-description">
                            <div class="recGreySec"></div>
                            Siti (Poligoni)
                        </label>
                    </div>
                </label>
            </li>
            <li class="gna-map-type" id="gna-concessione-type">
                <label for="gna-concessione-map-type-radio">
                    <input
                        type="radio"
                        class="gna-map-type-radio"
                        id="gna-concessione-map-type-radio"
                        name="gna-map-type"
                    />
                    <img
                        src="https://gna.cultura.gov.it/images/home3.jpg"
                        class="SBImg"
                        alt="Apri sezione nella mappa"
                        title="Apri sezione nella mappa"
                        class="image-thumb"
                        loading="lazy"
                    />
                    <h2>Indagini in concessione</h2>
                    <div class="gna-more-options-label">
                        <label class="gna-point-description">
                            <div class="gna-legend-point pointRed"></div>
                            Elemento puntuale
                        </label>
                        <label class="gna-point-description">
                            <div class="gna-legend-point pointBlue"></div>
                            Elemento puntale(estero)
                        </label>
                        <label class="gna-checkbox-layer-label" for="gna-dati-checkbox-concessione"
                            ><input
                                type="checkbox"
                                id="gna-dati-checkbox-concessione"
                            />Data GNA
                            </label>
                    </div>
                </label>
            </li>
            <li class="gna-map-type" id="gna-iccd-type">
                <label for="gna-iccd-map-type-radio">
                    <input
                        type="radio"
                        class="gna-map-type-radio"
                        id="gna-iccd-map-type-radio"
                        name="gna-map-type"
                    />
                    <img
                        src="https://gna.cultura.gov.it/images/home4.jpg"
                        class="SBImg"
                        alt="Apri sezione nella mappa"
                        title="Apri sezione nella mappa"
                        class="image-thumb"
                        loading="lazy"
                    />
                    <h2>Catalogo generale dei beni culturali (ICCD)</h2>
                    <div class="gna-more-options-label">
                        <label class="gna-point-description">
                            <div class="gna-legend-point pointBlue"></div>
                            Elemento puntale
                        </label>
                        <label class="gna-checkbox-layer-label" for="gna-dati-checkbox-iccd"
                            ><input
                                type="checkbox"
                                id="gna-dati-checkbox-iccd"
                            />Data GNA
                            </label>
                    </div>
                </label>
            </li>
            <li class="gna-map-type" id="gna-altre-banche-dati-type">
                <label for="gna-altre-banche-dati-map-type-radio">
                    <input
                        type="radio"
                        class="gna-map-type-radio"
                        id="gna-altre-banche-dati-map-type-radio"
                        name="gna-map-type"
                    />
                    <img
                        src="https://gna.cultura.gov.it/images/home2.jpg"
                        class="SBImg"
                        alt="Apri sezione nella mappa"
                        title="Apri sezione nella mappa"
                        class="image-thumb"
                        loading="lazy"
                    />
                    <h2>Altre banche dati</h2>
                    <div  class="gna-more-options-label">
                    <label class="gna-checkbox-layer-label" for="gna-dati-checkbox-censimento">
                            <input
                                type="checkbox"
                                id="gna-dati-checkbox-censimento"
                                checked
                            />Censimento (punti):  <span id="total-points-censimento">0</span></label
                        >
                        
                        <label class="gna-point-description">
                            <div class="gna-legend-point pointGreenSec"></div>
                            Elemento puntale
                        </label>
                        <label class="gna-checkbox-layer-label" for="gna-dati-checkbox-tess"
                            ><input
                                type="checkbox"
                                id="gna-dati-checkbox-tess"
                                checked
                            />Tess (punti): <span id="total-points-tess">0</span></label
                        >
                        <label class="gna-point-description">
                            <div class="gna-legend-point pointYellowSec"></div>
                            Elemento puntale
                        </label>
                    <label class="gna-checkbox-layer-label" for="gna-dati-checkbox-altre-banche-dati"
                            ><input
                                type="checkbox"
                                id="gna-dati-checkbox-altre-banche-dati"
                            />Data GNA
                            </label>
                    </div>
                </label>
            </li>
        </div>
    </div>
    <div class="gna-popup" id="gna-popup"></div>
    <div class="gna-modal" id="gna-modal">
        <div class="gna-modal-details" id="gna-modal-details">
            <div class="gna-modal-header" id="gna-modal-header">
                <h2 id="gna-modal-header-title"></h2>
                <button id="gna-close-modal-button"><i class="fa-solid fa-xmark"></i></button>
            </div>
            <div class="gna-modal-content" id="gna-modal-content">

            </div>
        </div>
    </div>
    <div class="gna-coords" id="gna-coords"></div>
`;

export { UI };
